<template>
  <div class="section">
    <div class="section_slide-three digital-slide">
      <div class="h-100">
        <VueSlickCarousel v-bind="sliderSettings" ref="carousel5">
          <div class="slide" v-for="slide in this.digital_slide.slides" :key="slide">
            <div class="container h-100 ">
              <div
                class="row align-center h-100 align-content-center col-gap-60"
              >
                <div class="col-lg-7">
                  <div class="infra-boxes">
                    <div class="row col-gap-50">
                      <div v-for="block in slide.blocks" :key="block" class="col-sm-6">
                        <div class="box">
                          <p>{{block}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-5">
                  <h4>
                    {{slide.title}}
                  </h4>
                  <div class="scrollWrapper">
                    <scrollbar :ops="scrollSettings">
                      <div class="scroll_pading">
                        <div class="desc">
                          <p v-for="desc in slide.desc" :key="desc">{{desc}}</p>
                        </div>
                      </div>
                    </scrollbar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VueSlickCarousel>
        <div class="slider__nav">
          <button
            @click.prevent="$refs.carousel5.prev()"
            class="slider__nav--previous"
          >
            <svg
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 35 64.806"
            >
              <use xlink:href="#glanceArrowleft"></use>
            </svg>
          </button>
          <button
            @click.prevent="$refs.carousel5.next()"
            class="slider__nav--next"
          >
            <svg
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 35 64.806"
            >
              <use xlink:href="#glanceNext"></use>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import digital_financial_services from "./json/digitalSlide.json";
export default {
  data() {
    return {digital_financial_services: digital_financial_services};
  },
  props: {
    sliderSettings: Object,
    scrollSettings: Object,
    digital_slide:Object
  },
  components: {
    VueSlickCarousel,
  },
};
</script>

<style lang="scss" scoped>
.digital-slide {
  /deep/ {
    .slider__nav {
      button {
        background: transparent;
        border-radius: 0;
        svg {
          transform: rotate(0);
        }
      }
    }
    .scrollWrapper {
      height: 450px;
      @media screen and (max-width: 991px) {
        height: 200px;
      }
    }
  }
}
[lang="ar"]{
  .section_slide-three.digital-slide{
    .slide {
      .infra-boxes{
        @media screen and (min-width:1200px){
          padding-top:120px;
        }
      }
    }
  }
}
</style>
